import { useState } from 'react';
import SegmentService from '../../../lib/segment/SegmentService';
import { SEGMENT_EVENTS } from '../../../lib/segment/SegmentEvents';

export default function useStepper(stepperSteps: string[]) {
    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => {
        SegmentService.track(SEGMENT_EVENTS.FeatureEngaged.key, {
            userType: 'Coach',
            location: `Coach Plans - ${stepperSteps[activeStep]}`,
            feature: 'Next'
        });
        const nextStep = activeStep + 1;
        setActiveStep(nextStep >= stepperSteps.length ? stepperSteps.length - 1 : nextStep);
    };

    const handleBack = () => {
        SegmentService.track(SEGMENT_EVENTS.FeatureEngaged.key, {
            userType: 'Coach',
            location: `Coach Plans - ${stepperSteps[activeStep]}`,
            feature: 'Back'
        });
        const prevStep = activeStep - 1;
        setActiveStep(prevStep < 0 ? 0 : prevStep);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return {
        steps: stepperSteps,
        activeStep,
        handleNext,
        handleBack,
        handleReset
    };
}
